var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadChatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18.094,
    viewBox: "0 0 18 18.094",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.047)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-93.382 -47.297)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M105.573,176h1.6a1.6,1.6,0,0,1,1.6,1.6v8.3a1.6,1.6,0,0,1-1.6,1.6H97.6a1.6,1.6,0,0,1-1.6-1.6v-8.3a1.6,1.6,0,0,1,1.6-1.6h1.6",
    transform: "translate(0 -122.894)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M176,56.935l3.191,3.191,3.191-3.191M179.191,48V59.488",
    transform: "translate(-76.809)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadChatIcon);
export default __webpack_public_path__ + "static/media/download-chat-icon.1fa7f60a208319faa353b78512ac9536.svg";
export { ForwardRef as ReactComponent };